<template>
  <div id="InventoryGoods">
    <div class="invoicingHead">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a @click="goBack" href="javascript:;">库存盘点</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>盘点商品</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="invoicingHeadDown">
      <div class="goodsDetail">
        <div>盘点单信息</div>
        <div class="info">
          <div>
            <!-- <div>单据：<el-input style="width:215px" v-model="orderCode"></el-input></div> -->
            <div class="mt10">
              盘点仓库：{{ checkedStock }}
              <!-- <el-select size="small" v-model="repositoryId" placeholder="请选择盘点仓库" class="ml10">
                                <el-option v-for="item in repositoryList" :key="item.repositoryId" :label="item.repositoryName" :value="item.repositoryId"></el-option>
                            </el-select> -->
            </div>
            <div class="mt10">
              业务日期：
              <el-date-picker
                v-model="dataTime"
                type="datetime"
                placeholder="选择业务日期"
                value-format="yyyy-MM-dd HH:mm"
              ></el-date-picker>
            </div>
          </div>
          <div class="pl120">
            <div>
              经手人：
              <el-select
                size="small"
                v-model="shopWorkerUserId"
                placeholder="经手人"
                class="ml10"
              >
                <el-option
                  v-for="item in handlerList"
                  :key="item.shopWorkerUserId"
                  :label="item.fullName"
                  :value="item.shopWorkerUserId"
                ></el-option>
              </el-select>
            </div>
            <div class="mt10">
              备注信息：<el-input style="width: 215px" v-model="checkRemark"></el-input>
            </div>
          </div>
          <div style="margin-top: 70px; margin-left: 70px">
            <el-button type="primary" plain size="middle" @click="goBack"
              >选择商品</el-button
            >
            <el-button type="primary" size="middle" @click="confirmChooseGoods"
              >完成</el-button
            >
          </div>
        </div>
      </div>
      <div class="title">盘点商品</div>
      <div class="content">
        <table class="table" width="100%" style="table-layout: fixed">
          <tr class="th">
            <td>盘点商品</td>
            <td>商品条码</td>
            <td>商品规格</td>
            <!-- <td>退货单价</td> -->
            <td>账面数量</td>
            <td>实际数量</td>
            <td>操作</td>
          </tr>
          <tr
            class="td"
            v-for="(item, index) in tableDataList"
            :key="index"
            style="border-bottom: 1px solid red"
          >
            <td style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
              <div class="flex-start">
                <div class="flex-start mr20">
                  <div>
                    <img
                      v-if="item.goodsImage"
                      class="edit-item_img"
                      style="margin: 10px 15px"
                      :src="item.goodsImage"
                      alt
                    />
                    <img
                      v-if="!item.goodsImage"
                      class="edit-item_img"
                      style="margin: 10px 15px"
                      src="@/assets/icon/defaultPic.png"
                      alt
                    />
                  </div>
                  <div style="padding: 35px 0">{{ item.goodsName }}</div>
                </div>
              </div>
            </td>
            <td>
              <span class="center">{{ item.goodsBarCode }}</span>
            </td>
            <td>
              <span class="center">{{ item.valueContent }}</span>
            </td>
            <!-- <td>
                            <span class="center">￥ {{item.takePrice.toFixed(2)}}</span>
                        </td> -->
            <td>
              <span class="center" v-if="item.isInfiniteStock == 0">{{
                item.qrcTotalStockCount
              }}</span>
              <span class="center" v-if="item.isInfiniteStock == 1">无限库存</span>
            </td>
            <td>
              <!-- <span class="flex-end mr20">
                                <el-input-number v-model="item.actualNum" size="small" @change="handleChange(item)" :max="goodList.isInfiniteStock == 0 ? goodList.qrcTotalStockCount : 999999999" :min="0"  label="描述文字"></el-input-number>
                            </span> -->
              <span class="center">{{ item.actualNum }}</span>
            </td>
            <td>
              <span class="flex-end mr20">
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="deleteGoods(item, index)"
                  >删除</el-button
                >
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { repositoryList, Shop_handlerList, modifyOrSaveGoodsCheck } from "../api";
export default {
  data() {
    return {
      checkedList: [],
      lists: [],
      repositoryId: "",
      repositoryList: [],
      handlerList: [],
      shopWorkerUserId: "",
      dataTime: new Date().pattern("yyyy-MM-dd HH:mm"),
      tableDataList: [],
      maxNum: 0,
      disabled: false,
      checkRemark: "",
      goodList: {},
      checkedStock: "",
    };
  },
  created() {
    this.getRepositoryList();
    this.checkedList = JSON.parse(localStorage.getItem("confirmChooseList") || "[]");
    var res = this.checkedList.filter(function (item, index, arr) {
      return item.click == true;
    });
    this.checkedStock = localStorage.getItem("checkedStock");
    console.log(res, "tableDataList");
    this.tableDataList = res;
    for (var i in this.tableDataList) {
      this.tableDataList[i].actualNum = this.tableDataList[i].goodsNum;
    }
    // var productJson = [];
    // this.tableDataList.forEach(function(item){
    //     if (item.isInfiniteStock == 0) {
    //         var bookNum = item.qrcTotalStockCount
    //     } else {
    //         var bookNum = 0
    //     }
    //     productJson.push({goodsId: item.goodsId, productId: item.productId, actualNum: item.actualNum, bookNum: bookNum,  goodsId: item.goodsId})
    // })
    // this.lists = productJson
    // console.log(this.lists, productJson)
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "/invoicing/chooseGoods",
        query: { goodsStyle: this.$route.query.goodsStyle },
      });
    },
    // 完成
    confirmChooseGoods() {
      console.log(this.checkedList, "checkedList");
      if (this.checkedList.length == 0) {
        this.$message.error("请选择商品");
        return;
      }
      var productJson = [];
      this.tableDataList.forEach(function (item) {
        if (item.isInfiniteStock == 0) {
          var bookNum = item.qrcTotalStockCount;
        } else {
          var bookNum = 0;
        }
        productJson.push({
          goodsId: item.goodsId,
          productId: item.productId,
          actualNum: item.actualNum,
          bookNum: bookNum,
          goodsId: item.goodsId,
        });
      });
      this.lists = productJson;
      modifyOrSaveGoodsCheck({
        isManager: 1,
        repositoryId: localStorage.getItem("checkRepositoryId"),
        handlerId: this.shopWorkerUserId,
        businessTime: this.dataTime,
        checkRemark: this.checkRemark,
        productJson: JSON.stringify(this.lists),
      }).then((res) => {
        if (res.code == 1) {
          this.$message.success(res.msg);
          this.$router.push("/invoicing/stockCheck");
          localStorage.removeItem("confirmChooseList");
        } else if (res.code == 0) {
          this.$message.error(res.msg);
        }
      });
    },
    // 改变实际数量
    handleChange(item) {
      // this.goodList = item
      // var index = this.checkedList.findIndex(item1 => {
      //     return item1.productId == item.productId
      // })
      // if (index !== -1) {
      //     console.log(this.checkedList[index].actualNum, this.tableDataList)
      //     var productJson = [];
      //     var that = this
      //     that.tableDataList.forEach(function(item){
      //         if (item.isInfiniteStock == 0) {
      //             var bookNum = item.qrcTotalStockCount
      //         } else {
      //             var bookNum = 0
      //         }
      //         productJson.push({goodsId: item.goodsId, productId: item.productId, actualNum: item.actualNum, bookNum: bookNum,  goodsId: item.goodsId})
      //     })
      //     that.lists = productJson
      //     console.log(that.lists, productJson)
      //     that.$forceUpdate()
      // }
    },
    // 仓库
    getRepositoryList() {
      repositoryList({
        isManager: 1,
        isNeedAll: 1,
        pageNo: 1,
        row: 9999,
      }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.repositoryList = res.data;
          this.repositoryId = res.data[0].repositoryId;
          this.Shop_handlerList();
        }
      });
    },
    // 经手人列表
    Shop_handlerList() {
      Shop_handlerList({
        isManager: 1,
        pageNo: 1,
        row: 99999,
      }).then((res) => {
        if (res.code == 1) {
          this.handlerList = res.data[0].workers;
          this.shopWorkerUserId = res.data[0].workers[0].shopWorkerUserId;
        }
      });
    },
    // 删除
    deleteGoods(item, index) {
      console.log(item, index);
      this.tableDataList.splice(index, 1);
      this.checkedList.splice(index, 1);
      localStorage.setItem("confirmChooseList", JSON.stringify(this.checkedList));
    },
  },
};
</script>

<style scoped>
.goodsDetail {
  width: calc(100vw - 280px);
  height: auto;
  background-color: #f8f8f8;
  padding: 20px;
}
.info {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-top: 20px;
  box-sizing: border-box;
  font-size: 14px;
  color: #737373;
}
.pl120 {
  padding-left: 120px;
  box-sizing: border-box;
}
.mt10 {
  margin-top: 10px;
}
.mr20 {
  margin-right: 20px;
}
.mt20 {
  margin-top: 20px;
}
.mt5 {
  margin-top: 5px;
}
.mr10 {
  margin-right: 10px;
}
.title {
  width: calc(100vw - 245px);
  height: 50px;
  line-height: 50px;
  margin: 20px auto;
  background-color: #f8f8f8;
  font-size: 15px;
  padding-left: 20px;
  box-sizing: border-box;
}
.content {
  width: calc(100vw - 250px);
  height: 550px;
  overflow-y: scroll;
  color: #606266;
  font-size: 14px;
}
table {
  border: 0;
  border-collapse: 0;
  border-spacing: 0;
  font-size: 14px;
}
.table {
  width: 100%;
  font-size: 12px;
}
.th {
  background: #f8f8f8;
  padding: 15px;
  height: 40px;
  font-size: 14px;
  color: #909399;
  font-weight: 600;
}
.td td {
  height: 55px;
  border-bottom: 1px solid #ebeef5;
  /* text-align: center;     */
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用*/
}
.th td {
  font-size: 14px;
  border-bottom: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  text-align: center;
}
.th td:first-child {
  text-align: left;
  padding-left: 17px;
}
.th td:last-child {
  text-align: right;
  padding-right: 28px;
}
td {
  font-size: 14px;
  padding: 0;
  margin: 0;
}
.edit-item_img {
  height: 65px;
  width: 65px;
}
.center {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.flex-end {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.flex-column-start {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
}
.flex-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}
.flex-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
}
</style>
